export const resolutions = {
    full_hd: '1080p',
    hd: '720p',
    md: '360p',
    sd: '240p',
};

export const PER_PAGE = 16;